import * as Yup from 'yup';
import { EncargoPrevistoRealizado } from './model';
export class EncargoSchema {
  public static id() {
    return Yup.number().positive('ID deve ser um maior que zero');
  }
  public static record() {
    return Yup.object().shape(recordShape);
  }
  public static createForm() {
    const { anoMesReferencia, volumeEnergiaHora, previstoRealizado } = recordShape;

    const createFormShape = {
      anoMesReferencia,
      volumeEnergiaHora,
      previstoRealizado
    };

    return Yup.object().shape(createFormShape);
  }
  public static updateForm() {
    const { anoMesReferencia, volumeEnergiaHora, previstoRealizado } = recordShape;

    const updateFormShape = {
      anoMesReferencia,
      volumeEnergiaHora,
      previstoRealizado
    };

    return Yup.object().shape(updateFormShape);
  }
}

const recordShape = {
  anoMesReferencia: Yup.string(),
  volumeEnergiaHora: Yup.number(),
  previstoRealizado: Yup.mixed<EncargoPrevistoRealizado>()
    .oneOf(Object.values(EncargoPrevistoRealizado), `Previsto/Realizado deve ser "${Object.values(EncargoPrevistoRealizado).join('" ou "')}"`)
    .required('Previsto/Realizado é obrigatório')
};
